import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { ExperienceType } from '@apply/constants';
import { useNavigate } from 'react-router';

export interface EditButtonProps {
    experienceId: number | undefined;
    experienceTypeId: number | undefined;
    isVerified: boolean;
}

export const EditButton: React.FC<EditButtonProps> = ({ experienceId, experienceTypeId, isVerified }) => {
    const navigate = useNavigate();
    const mobileScreen = isMobileScreen();
    if (!experienceId) {
        return;
    }

    const isVisible = !(experienceTypeId !== ExperienceType.NonBfi || (isVerified && experienceTypeId === ExperienceType.NonBfi));
    const isDisabled = experienceTypeId !== ExperienceType.NonBfi || isVerified;

    const handleEditExperienceButtonClick = () => {
        navigate(`/experience/property/${experienceId}`);
        window.scrollTo(0, 0);
    };

    return (
        <>
            {isVisible && (
                <IconButton
                    id='editExperienceButton'
                    theme={IconButtonTheme.DarkBlueActive}
                    icon={faEdit}
                    size={IconButtonSize.Small}
                    disabled={isDisabled}
                    handleClick={handleEditExperienceButtonClick}
                />
            )}
        </>
    );
};
